import MetaData from '../../common/model/Metadata';
export default class CommonResponse {
    constructor(response) {
        this.metadata = new MetaData(response === null || response === void 0 ? void 0 : response.meta);
    }
}
